import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Box, IconButton, Typography } from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useMotiveMobileStyles } from './styles';
import IssueMapper from '../../../../helpers/IssueMapper';
import { setAuthorized } from '../../../../redux/slices/RoutesAuthSlice';

const MotiveMobile = ({ ...props }) => {
  const { issueId, motives } = props;
  const classes = useMotiveMobileStyles();
  const dispatch = useDispatch();

  const handleLinkClick = (event, authorized) => {
    if (authorized && authorized !== undefined)
      dispatch(setAuthorized(authorized));
  };

  return (
    <Box width="100%">
      {motives.map((motive, index) => (
        <React.Fragment key={index}>
          <Link
            className={classes.link}
            to={{
              search: `?issueId=${issueId}&motiveId=${motive.id}&issueFormName=${motive.issueFormName}`,
              pathname: IssueMapper.get(motive.id),
            }}
            onClick={(event) => handleLinkClick(event, motive.authorized)}
          >
            <Box className={classes.boxMotive}>
              <Typography className={classes.title}>{motive.title}</Typography>
              <IconButton>
                <KeyboardArrowRightIcon />
              </IconButton>
            </Box>
          </Link>
        </React.Fragment>
      ))}
    </Box>
  );
};

MotiveMobile.propTypes = {
  motives: PropTypes.array,
  issueId: PropTypes.string,
};

export default MotiveMobile;
